import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { Platform } from 'react-native';

const firebaseConfig = {
  apiKey: "AIzaSyDQXWgWWIE49QVs2gF-Zp2HEo97k_ZauFA",
  authDomain: "nicespressogame.firebaseapp.com",
  projectId: "nicespressogame",
  storageBucket: "nicespressogame.firebasestorage.app",
  messagingSenderId: "317007594925",
  appId: "1:317007594925:android:d02af34b8119140fe3cd24",
  measurementId: "G-XXXXXXXXXX"
};

// Initialize Firebase for web (React Native Firebase will be configured separately)
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };